/**
 * Modellnamnen från TecDoc bär chassikoden i parentes: "TOURAN (1T1, 1T2)",
 * "207 (WA_, WC_)". För kunden är det brus (ägaren 2026-09-16: "känns som
 * onödig fakta") — men för den som vet vad koden betyder är den värdefull, så
 * den visas i stället som en egen spec på fordonssidan.
 *
 * Slugs, matchning mot databasen och JSON-LD använder fortfarande det
 * fullständiga namnet; det här är bara visning.
 */
export function visaModell(model: string | null | undefined): string {
  return (model ?? '').replace(/\s*\([^)]*\)/g, '').replace(/\s{2,}/g, ' ').trim();
}

/** "TOURAN (1T1, 1T2)" → "1T1, 1T2"; tomt om ingen parentes finns. */
export function chassikod(model: string | null | undefined): string {
  const m = (model ?? '').match(/\(([^)]*)\)/);
  return m ? m[1]!.trim() : '';
}
